import type { ContentTypeCode } from '@/services/cms'

export const EXPLORE_VIVERSE_CONTENT_TYPES: ContentTypeCode[] = ['games', 'experiences']
